$(window).load(function(){
  if($('.product-single__thumbnails-product-template').length) 
  $('.product-single__thumbnails-product-template')[0].slick.refresh();

  $('.popupCloseButton').click(function(){
    $('.popup_wildthing').hide();
  });
  // if ($.cookie('popup_status') != 'show') {
  //     setTimeout(function () {
  //       $('.popup_wildthing').show();
  //     }, 4000);
  //   $.cookie('popup_status', 'show', { expires: 7 }); 
  // }
});
$(document).ready(function(){
  $('.product-single__thumbnails-product-template').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    vertical: true,
    centerMode: false,
    verticalSwiping: true
  });
  /*product readmore*/
  $("#showmore").click(function(e) {
    e.preventDefault();
    if($(window).width()<768) {
      $('html,body').animate({ scrollTop: $(".showonmob #dec").offset().top - 100 },'slow');
    } else {
      $('html,body').animate({ scrollTop: $(".hideonmob #dec").offset().top - 100 },'slow');
    }
  });
  /*Product Accordion*/

  function close_accordion_section() {
    jQuery('.accordion .accordion-section-title').removeClass('active');
    jQuery('.accordion .accordion-section-content').slideUp(300).removeClass('open');
  }

  jQuery('.accordion-section-title').click(function(e) {
    // Grab current anchor value
    var currentAttrValue = jQuery(this).attr('href');

    if(jQuery(e.target).is('.active')) {
      close_accordion_section();
    }else {
      close_accordion_section();

      // Add active class to section title
      jQuery(this).addClass('active');
      // Open up the hidden content panel
      jQuery('.accordion ' + currentAttrValue).slideDown(300).addClass('open'); 
    }
    e.preventDefault();
  });
  /* product QTY */
  $('.add').click(function () {
    $(this).prev().val(+$(this).prev().val() + 1);
  });
  $('.sub').click(function () {
    if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
  });
   
  $('[href="#openChat"]').on('click', function(){
    $zopim.livechat.window.show();
  });
  
  $('#insta-feed a, #insta-feed img').removeAttr('title');
  setTimeout(function(){ 
    $('#insta-feed a, #insta-feed img').removeAttr('title');
  }, 3000);


  // $(window).scroll(function() {  
  //   if($(window).width() < 768) {
  //     var scroll = $(window).scrollTop();
  //     if (scroll >= 10) {
  //       $(".notification-bar").slideUp();
  //     } else {
  //       $(".notification-bar").slideDown();
  //     }
  //   } else {
  //     $(".notification-bar").slideDown();
  //   }
  // });
  $('.personalizePro a').on('click', function(){
    $('#personalizeContent').slideToggle("slow");
    imageAlt();
  });
   $('.postpersonalizePro a').on('click', function(){
    $('#postpersonalizeContent').slideToggle("slow");
  });
  function imageAlt(){
    $( ".product-single__thumbnails li" ).each(function( index ) {
      var imgAlt = $(this).find('img').attr('alt');
      if(imgAlt == "engrave")
      {
        $(this).find('a').trigger('click');
//         $('.product-single__photo').css("pointer-events","none");
        $('input#your-message').keyup(function() {
//           $('.eng-txt').html('');
//           $('.eng-txt').remove();
          if(!$('.product-single__photo .eng-txt').length){
            $('.product-single__photo').append('<span maxlength="10" class="eng-txt" style="display: none;">'+$(this).val()+'</span>');
          }
          $('.product-single__photo .eng-txt').text($(this).val());
          if($('.product-single__photo .slide-image.slick-current[data-img_position="'+ show_position_img +'"]').length){
            $('.eng-txt').show();
          }else{
            $('.eng-txt').hide();
          }
        });
        $("select#text-size").on("change keyup paste", function(){
          var textSize = this.value;
          $('.eng-txt').css({'font-size': textSize+'px' });
        });

        $("select#font-type").on("change keyup paste", function(){
          var textstyle = this.value;
          $('.eng-txt').css("font-family", $(this).val());
        });
      }
    });
  }
  $( ".product-single__thumbnails li" ).on('click', function(){
   var imgAlts = $(this).find('img').attr('alt');
     if(imgAlts != "engrave"){
//         $('.eng-txt').hide();
//         $('#personalizeContent').slideUp("slow");
//         $('#your-message').val("");
        $("#text-size").prop("selectedIndex", 0);
        $("#font-type").prop("selectedIndex", 0);
//         $('.product-single__photo').css("pointer-events","auto");
     }
     else{
//         $('.product-single__photo').css("pointer-events","none");
     }
  });
  $('.product-form').on('submit',function(){
    if($('#personalizeContent:visible').length >0){
      var x = true;
      $(this).find('.err-msg').remove();
      var name = $(this).find('#your-message');
      var size = $(this).find('#text-size');
      var font = $(this).find('#font-type');
      if(name.val() == ''){
        name.css('border-bottom','1px solid red');
        name.parent().append('<p class="err-msg">Please enter Your Message.</p>');
        x = false;
      } else {
        name.css('border-bottom','1px solid #000');
        name.parent().find('.err-msg').remove();
      }
      if(size.val() == '' || size.val() == 'Please select'){
        size.css('border-bottom','1px solid red');
        size.parent().append('<p class="err-msg">Please Select Text Size.</p>');
        x = false;
      } else {
        size.css('border-bottom','1px solid #000');
        size.parent().find('.err-msg').remove();
      }
      if(font.val() == '' || font.val() == 'Please select'){
        font.css('border-bottom','1px solid red');
        font.parent().append('<p class="err-msg">Please Select Font Type.</p>');
        x = false;
      } else {
        font.css('border-bottom','1px solid #000');
        font.parent().find('.err-msg').remove();
      }
      if(x==false) {
        return false;
      }
    }
  });
  $("a.star_icon_widget").on('click', function(event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top-100
      }, 1000, function(){
        window.location.hash = hash;
      });
    }
  });
  
  $('.related_product_loop').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 561,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
   $('.idx-logo .logo-section').slick({
    slidesToShow: 5,
    autoplay: true,
    arrows:false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }]
  });

});


$('.shipping-accordion_title').click(function() {
    $('.shipping-accordion_title').removeClass('active');
    $('.shipping-accordion_content_wp').slideUp();
    if (!$(this).next().is(':visible')) {
        $(this).next().slideDown();
        $(this).addClass('active');
    }
});

$('.shipping-btns .btn').click(function(e){
  e.preventDefault();
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top - 110;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
  }
});